import { List, Map, fromJS } from 'immutable';
import * as constAction from 'root/actionConstants';

var defaultState = Map({
  lista: List(),
  grupo: Map(),
  listaUsuariosBuscados: List(),
  eliminarId: false,
});

export default function reducer(state = defaultState, action) {
  switch (action.type) {
    case constAction.GRUPOS_CLEAR: {
      if (action.payload === 'all') return defaultState;
      else if (defaultState.has(action.payload)) return state.set(action.payload, defaultState.get(action.payload));
      else {
        console.error('No existe la propiedad ' + action.payload);
        return state;
      }
    }
    case constAction.GRUPOS_SET_STATE: {
      let newState = state;
      for (var key in action.payload) {
        newState = newState.set(key, fromJS(action.payload[key]));
      }
      return newState;
    }
    case constAction.GRUPOS_MODIFICAR_USUARIOS_STATE: {
      let usuariosList = state.getIn(['grupo', '_usuarios']);

      if (usuariosList) {
        let { usuario } = action.payload;

        const indexOf = usuariosList.findIndex(user => user.get('id') === usuario.get('id'));
        if (indexOf !== -1) return state.setIn(['grupo', '_usuarios'], usuariosList.delete(indexOf));
        else if (indexOf === -1) return state.setIn(['grupo', '_usuarios'], usuariosList.push(usuario));
      }
      return state;
    }
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// src/modules/grupos/reducer.js